module.exports = __webpack_public_path__ + "img/yml_gallery10.8fa64f6f.jpg";